import styled from "styled-components";

const SelectButton = styled.button`
  border: none;
  outline: none;
  background: white;
  border-radius: 8px;
  border: 1px solid #e9e9e9;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
`;

const FiltersContainer = styled.div`
  height: auto;
  z-index: 2;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  z-index: 2;
`;

const modules = {
  SelectButton,
  FiltersContainer,
  CloseButton,
};

export default modules;
